// Sibling imports
const {
  CONTACTS_FAILED,
  CONTACTS_LOADED,
  CONTACTS_LOADING,
  UPDATE
} = require('./actions')
const SelfUserRecord = require('./record')

function userReducer(state = new SelfUserRecord(), { type, payload }) {
  switch (type) {
    case CONTACTS_FAILED:
    return state.setContactsFailed()
    case CONTACTS_LOADED:
      return state.setContacts(payload.contacts)
    case CONTACTS_LOADING:
      return state.setContactsLoading()
    case UPDATE:
      return state.mergeDeep(payload)
    default:
      return state
  }
}

module.exports = userReducer
